"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeedbackModal;
var _react = _interopRequireWildcard(require("react"));
var _reactToastify = require("react-toastify");
var _AssistantProvider = require("./AssistantProvider");
var _feedbackCategories = _interopRequireDefault(require("./feedback-categories.json"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const API_URL = "".concat(process.env.REACT_APP_CHAT_AGENT_DOMAIN || 'http://localhost:8080', "/v1/ai/feedback/");
function FeedbackModal() {
  const {
    feedbackOpen,
    feedbackMessageId,
    closeFeedback,
    threadIdRef
  } = (0, _AssistantProvider.useAssistant)();
  const [rating, setRating] = (0, _react.useState)(0);
  const [selectedTags, setSelectedTags] = (0, _react.useState)([]);
  const [details, setDetails] = (0, _react.useState)('');
  const [detailsInvalid, setDetailsInvalid] = (0, _react.useState)(false);
  const [submitting, setSubmitting] = (0, _react.useState)(false);
  const [submitted, setSubmitted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (feedbackOpen) {
      setRating(0);
      setSelectedTags([]);
      setDetails('');
      setDetailsInvalid(false);
      setSubmitting(false);
      setSubmitted(false);
    }
  }, [feedbackOpen]);
  (0, _react.useEffect)(() => {
    setSelectedTags([]);
    setDetailsInvalid(false);
  }, [rating]);
  if (!feedbackOpen) return null;
  const currentBucket = _feedbackCategories.default.ratingBuckets.find(b => b.stars.includes(rating));
  const allowedCategories = currentBucket ? _feedbackCategories.default.categories.filter(c => currentBucket.allowedCategoryCodes.includes(c.code)) : [];
  const toggleTag = label => {
    setSelectedTags(prev => prev.includes(label) ? prev.filter(t => t !== label) : [...prev, label]);
  };
  const hasOtherTag = selectedTags.some(t => /^others?$/i.test(t));
  const detailsRequired = rating === 1 || rating === 2 || hasOtherTag;
  const handleSubmit = async () => {
    if (detailsRequired && details.trim().length < 5) {
      setDetailsInvalid(true);
      return;
    }
    setSubmitting(true);
    const body = {
      message: details,
      rating,
      tags: selectedTags
    };
    const threadId = threadIdRef === null || threadIdRef === void 0 ? void 0 : threadIdRef.current;
    if (threadId) body.thread_id = threadId;
    if (feedbackMessageId) body.message_id = feedbackMessageId;
    const headers = {
      'Content-Type': 'application/json',
      'X-Upstream-Env': process.env.REACT_APP_HCP_ENV
    };
    if (threadId) {
      headers['X-Correlation-ID'] = threadId;
      headers['X-Thread-ID'] = threadId;
    }
    let userKey = localStorage.getItem("CognitoIdentityServiceProvider.".concat(process.env.REACT_APP_USER_POOL_CLIENT_ID, ".LastAuthUser"));
    if (userKey) {
      const jwt = localStorage.getItem("CognitoIdentityServiceProvider.".concat(process.env.REACT_APP_USER_POOL_CLIENT_ID, ".").concat(userKey, ".idToken"));
      if (jwt) headers['Authorization'] = "Bearer ".concat(jwt);
    }
    try {
      var _data$metadata;
      const res = await fetch(API_URL, {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
      });
      if (!res.ok) {
        _reactToastify.toast.error("Feedback API error: status ".concat(res.status, " - ").concat(res.statusText));
        setSubmitting(false);
        return;
      }
      const data = await res.json();
      const returnedId = data.thread_id || data.correlation_id || (data === null || data === void 0 || (_data$metadata = data.metadata) === null || _data$metadata === void 0 ? void 0 : _data$metadata.thread_id);
      if (returnedId && threadIdRef) threadIdRef.current = returnedId;
      _reactToastify.toast.success('Feedback submitted successfully!');
      setSubmitted(true);
      setTimeout(() => closeFeedback(), 1500);
    } catch (err) {
      console.error('Feedback submission error:', err);
      _reactToastify.toast.error('Failed to submit feedback. Please try again.');
      setSubmitting(false);
    }
  };
  return (0, _jsxRuntime.jsx)("div", {
    className: "tw-fixed tw-inset-0 tw-z-[10001] tw-flex tw-items-center tw-justify-center tw-bg-black/40",
    onClick: closeFeedback,
    children: (0, _jsxRuntime.jsx)("div", {
      className: "tw-bg-sa-surface tw-rounded-bubble tw-shadow-sa-lg tw-w-[420px] tw-max-w-[90vw] tw-max-h-[85vh] tw-overflow-y-auto tw-p-5 tw-font-sa tw-text-sm tw-text-sa-text tw-animate-sa-slide-in",
      onClick: e => e.stopPropagation(),
      children: submitted ? (0, _jsxRuntime.jsxs)("div", {
        className: "tw-text-center tw-py-8",
        children: [(0, _jsxRuntime.jsx)("span", {
          className: "tw-text-4xl",
          children: "\u2705"
        }), (0, _jsxRuntime.jsx)("p", {
          className: "tw-mt-3 tw-font-semibold",
          children: "Thank you for your feedback!"
        })]
      }) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)("h2", {
          className: "tw-text-base tw-font-bold tw-text-center tw-mb-3",
          children: rating < 3 && rating > 0 ? 'What went wrong?' : rating >= 3 ? 'What worked well?' : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: ["How would you rate your chat", (0, _jsxRuntime.jsx)("br", {}), "experience today?"]
          })
        }), (0, _jsxRuntime.jsx)("div", {
          className: "tw-flex tw-justify-center tw-gap-1.5 tw-mb-3",
          children: [0, 1, 2, 3, 4].map(i => (0, _jsxRuntime.jsx)("button", {
            className: "tw-text-3xl tw-bg-transparent tw-border-none tw-cursor-pointer tw-transition-transform hover:tw-scale-110 ".concat(i < rating ? 'tw-text-yellow-400' : 'tw-text-gray-300'),
            onClick: () => setRating(i + 1),
            "aria-label": "Rate ".concat(i + 1, " star").concat(i > 0 ? 's' : ''),
            children: "\u2605"
          }, i))
        }), (0, _jsxRuntime.jsx)("hr", {
          className: "tw-border-sa-border tw-my-3"
        }), rating > 0 && allowedCategories.length > 0 && (0, _jsxRuntime.jsx)("div", {
          className: "tw-flex tw-flex-wrap tw-gap-2 tw-mb-3",
          children: allowedCategories.map(cat => (0, _jsxRuntime.jsxs)("button", {
            className: "tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-md tw-border tw-text-xs tw-font-sa tw-cursor-pointer tw-transition-colors ".concat(selectedTags.includes(cat.label) ? 'tw-bg-sa-primary tw-text-white tw-border-sa-primary tw-font-bold' : 'tw-bg-gray-100 tw-text-sa-text tw-border-gray-300 hover:tw-bg-blue-50 hover:tw-text-sa-primary hover:tw-border-blue-300'),
            onClick: () => toggleTag(cat.label),
            children: [cat.icon, " ", cat.label]
          }, cat.code))
        }), (0, _jsxRuntime.jsxs)("h3", {
          className: "tw-text-sm tw-font-semibold tw-mb-1.5",
          children: [_feedbackCategories.default.ui.fields.freeText.label, detailsRequired && (0, _jsxRuntime.jsx)("span", {
            className: "tw-text-sa-error",
            children: " *"
          })]
        }), (0, _jsxRuntime.jsx)("textarea", {
          className: "tw-w-full tw-min-h-[80px] tw-p-2.5 tw-rounded-md tw-border tw-text-sm tw-font-sa tw-text-sa-text tw-bg-sa-surface-alt tw-resize-y tw-outline-none focus:tw-border-sa-primary tw-transition-colors ".concat(detailsInvalid ? 'tw-border-sa-error' : 'tw-border-sa-border'),
          style: {
            boxSizing: 'border-box',
            display: 'block'
          },
          placeholder: _feedbackCategories.default.ui.fields.freeText.placeholder,
          value: details,
          onChange: e => {
            setDetails(e.target.value);
            if (detailsInvalid && e.target.value.trim().length >= 5) setDetailsInvalid(false);
          }
        }), (0, _jsxRuntime.jsxs)("div", {
          className: "tw-flex tw-justify-end tw-gap-2 tw-mt-3",
          children: [(0, _jsxRuntime.jsx)("button", {
            className: "tw-px-4 tw-py-2 tw-rounded-md tw-border tw-border-sa-border tw-bg-transparent tw-text-sa-text-sec tw-text-sm tw-font-sa tw-cursor-pointer hover:tw-bg-gray-100 tw-transition-colors",
            onClick: closeFeedback,
            children: "Cancel"
          }), (0, _jsxRuntime.jsx)("button", {
            className: "tw-px-4 tw-py-2 tw-rounded-md tw-border-none tw-bg-sa-primary tw-text-white tw-text-sm tw-font-semibold tw-font-sa tw-cursor-pointer hover:tw-bg-sa-primary-h tw-transition-colors disabled:tw-opacity-40 disabled:tw-cursor-default",
            disabled: rating === 0 || selectedTags.length === 0 || submitting,
            onClick: handleSubmit,
            children: submitting ? 'Submitting…' : 'Submit'
          })]
        })]
      })
    })
  });
}